import { render } from "./course-quiz-results.vue?vue&type=template&id=1879f1c5&ts=true"
import script from "./course-quiz-results.vue?vue&type=script&lang=ts"
export * from "./course-quiz-results.vue?vue&type=script&lang=ts"

import "./course-quiz-results.vue?vue&type=style&index=0&id=1879f1c5&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__